import { Timeline } from 'types';
import { CSSProperties } from 'react';
import { times } from 'util/times';

export const rasterizeBars = (timeline: Timeline, styles: { [name: string]: CSSProperties }): string[] => {
    const { bars, segments, segmentWidth, segmentHeight } = timeline;

    // Create a canvas that is the size of one segment of the timeline (e.g. half an hour by default)
    // The timeline bars are already scaled into pixel coordinates.
    const canvas = document.createElement('canvas');
    canvas.height = segmentHeight;
    canvas.width = segmentWidth;

    const ctx = canvas.getContext('2d')!;
    
    return times(segments, i => {
        ctx.fillStyle = styles.Workspace.backgroundColor as string;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = styles.Timeline.backgroundColor as string;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Shift all the bars to the left so the current segment is aligned to the viewable area in the canvas
        const offset = i * segmentWidth;

        // Find the bars that are visible in the current segment
        const visibleBars = bars.filter(bar =>
            bar.x + bar.width >= offset &&
            bar.x < offset + segmentWidth
        );
        
        visibleBars.forEach((bar, i) => {
            const { x, width, y, height, type } = bar;

            // Clip bars so we're not drawing outside of the canvas
            // (relying on Chome 68 to do clipping was causing undesired visual artifacts sometimes)
            const translatedX = x - offset;
            const deltaWidth = Math.min(translatedX, 0);
            const clippedX = Math.max(translatedX, 0);
            const maxWidth = segmentWidth - clippedX;
            const clippedWidth = Math.min(width + deltaWidth, maxWidth);

            ctx.fillStyle = styles.TimelineBar[type].fill || '#000';
            ctx.fillRect(clippedX, y, clippedWidth, height);
        });
    
        return canvas.toDataURL();
    });
};



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/timeline/rasterizeBars.ts